module.exports = __webpack_public_path__ + "img/vegetable-turnips-350x184.90a9c85d.jpg";